export const nameComponentObj = {
  "inventoryEntryManage": {
    name: "inventoryEntryManage",
    label: "库存管理/入库管理",
    permissionIdentification: "inventory:entry:list", // 权限标识
    recycleBinIdentification: "inventory.Entry", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/entry/index.vue")
  },
  "inventoryOutManage": {
    name: "inventoryOutManage",
    label: "库存管理/出库管理",
    permissionIdentification: "inventory:out:list", // 权限标识
    recycleBinIdentification: "inventory.Out", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/out/index.vue")
  },
  "inventoryMoveManage": {
    name: "inventoryMoveManage",
    label: "库存管理/移库管理",
    permissionIdentification: "inventory:move:list", // 权限标识
    recycleBinIdentification: "inventory.Move", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/move/index.vue")
  },
  "inventoryCheckManage": {
    name: "inventoryCheckManage",
    label: "库存管理/盘库管理",
    permissionIdentification: "inventory:check:list", // 权限标识
    recycleBinIdentification: "inventory.Check", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/check/index.vue")
  },
  "inventoryRecordManage": {
    name: "inventoryRecordManage",
    label: "库存管理/库存记录",
    permissionIdentification: "inventory:record:list", // 权限标识
    recycleBinIdentification: "inventory.Record", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/record/index.vue")
  },
  "inventoryStatisticsManage": {
    name: "inventoryStatisticsManage",
    label: "库存报表/库存统计",
    permissionIdentification: "inventory:statistics:list", // 权限标识
    recycleBinIdentification: "inventory.Statistics", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/statistics/index.vue")
  },
  "inventoryGoodsManage": {
    name: "inventoryGoodsManage",
    label: "库存报表/商品统计",
    permissionIdentification: "inventory:goods:list", // 权限标识
    recycleBinIdentification: "inventory.Goods", // 数据库表权限标识 回收站使用
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/goods/index.vue")
  },
  "inventoryLendManage": {
    name: "inventoryLendManage",
    label: "出库报表/外借统计",
    permissionIdentification: "inventory:lend:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/lend/index.vue")
  },
  "inventorySalesManage": {
    name: "inventorySalesManage",
    label: "出库报表/销售统计",
    permissionIdentification: "inventory:sales:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/sales/index.vue")
  },

  "inventoryDamageManage": {
    name: "inventoryDamageManage",
    label: "出库报表/过损统计",
    permissionIdentification: "inventory:damage:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/damage/index.vue")
  },
  "inventoryProduceManage": {
    name: "inventoryProduceManage",
    label: "入库报表/生产统计",
    permissionIdentification: "inventory:produce:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/produce/index.vue")
  },
  "inventoryPurchaseManage": {
    name: "inventoryPurchaseManage",
    label: "入库报表/采购统计",
    permissionIdentification: "inventory:purchase:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/purchase/index.vue")
  },
  "inventoryReturnGoodsManage": {
    name: "inventoryReturnGoodsManage",
    label: "入库报表/退货统计",
    permissionIdentification: "inventory:returnGoods:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/return-goods/index.vue")
  },
  "inventoryReturnManage": {
    name: "inventoryReturnManage",
    label: "入库报表/归还统计",
    permissionIdentification: "inventory:return:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/return/index.vue")
  },
  "inventorySpuWarningManage": {
    name: "inventorySpuWarningManage",
    label: "预警管理/库存预警",
    permissionIdentification: "inventory:spuWarning:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/spu-warning/index.vue")
  },
  "inventoryExpireWarningManage": {
    name: "inventoryExpireWarningManage",
    label: "预警管理/过期预警",
    permissionIdentification: "inventory:expireWarning:list", // 权限标识
    component: () => import(/* webpackChunkName: "inventoryModule" */"@/views/inventory/expire-warning/index.vue")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  inventoryEntryCreate: {
    label: "库存管理/入库管理/新增入库单",
    value: "inventory:entry:create"
  },
  inventoryEntryDelete: {
    label: "库存管理/入库管理/删除入库单",
    value: "inventory:entry:delete"
  },
  inventoryEntryUpdate: {
    label: "库存管理/入库管理/更新入库单",
    value: "inventory:entry:update"
  },
  inventoryEntryRead: {
    label: "库存管理/入库管理/查看入库单",
    value: "inventory:entry:read"
  },
  inventoryEntryDiscard: {
    label: "库存管理/入库管理/作废入库单",
    value: "inventory:entry:discard"
  },

  inventoryOutCreate: {
    label: "库存管理/出库管理/新增出库单",
    value: "inventory:out:create"
  },
  inventoryOutDelete: {
    label: "库存管理/出库管理/删除出库单",
    value: "inventory:out:delete"
  },
  inventoryOutUpdate: {
    label: "库存管理/出库管理/更新出库单",
    value: "inventory:out:update"
  },
  inventoryOutRead: {
    label: "库存管理/出库管理/查看出库单",
    value: "inventory:out:read"
  },
  inventoryOutDiscard: {
    label: "库存管理/出库管理/作废出库单",
    value: "inventory:out:discard"
  },

  inventoryMoveCreate: {
    label: "库存管理/移库管理/新增移库单",
    value: "inventory:move:create"
  },
  inventoryMoveDelete: {
    label: "库存管理/移库管理/删除移库单",
    value: "inventory:move:delete"
  },
  inventoryMoveUpdate: {
    label: "库存管理/移库管理/更新移库单",
    value: "inventory:move:update"
  },
  inventoryMoveRead: {
    label: "库存管理/移库管理/查看移库单",
    value: "inventory:move:read"
  },
  inventoryMoveDiscard: {
    label: "库存管理/移库管理/作废移库单",
    value: "inventory:move:discard"
  },

  inventoryCheckCreate: {
    label: "库存管理/盘库管理/新增盘库单",
    value: "inventory:check:create"
  },
  inventoryCheckDelete: {
    label: "库存管理/盘库管理/删除盘库单",
    value: "inventory:check:delete"
  },
  inventoryCheckUpdate: {
    label: "库存管理/盘库管理/更新盘库单",
    value: "inventory:check:update"
  },
  inventoryCheckRead: {
    label: "库存管理/盘库管理/查看盘库单",
    value: "inventory:check:read"
  },
  inventoryCheckDiscard: {
    label: "库存管理/盘库管理/作废盘库单",
    value: "inventory:check:discard"
  },
  inventoryLendUrge: {
    label: "出库报表/外借统计/催还",
    value: "inventory:lend:urge"
  }
}